import { Injectable } from '@angular/core';

export interface CreateFormResult {
  name: string;
}

@Injectable()
export abstract class CreateFormStrategy {
  abstract readonly header: string;
  abstract readonly namePlaceholder: string;
  abstract readonly createButtonLabel: string;
  abstract readonly cancelButtonLabel: string;
}
